import { combineReducers } from 'redux';

import { landingReducer } from '../modules/landing/LandingReducer';

const rootReducer = combineReducers({
  landing: landingReducer,
});

export default rootReducer;
